import React from 'react';
import formDataStorage from '../../utils/formDataStorage';
import { AlertTriangle, ShieldAlert, Users, Vote, DollarSign, GraduationCap } from 'lucide-react';

const Part5Form = ({ data, onChange }) => {

  // 从formDataStorage读取数据并确保数据同步
  React.useEffect(() => {
    console.log('Part5Form useEffect - 初始化数据检查');
    const savedData = formDataStorage.loadFormData('part5');
    console.log('Part5Form useEffect - 已保存数据:', savedData);
    console.log('Part5Form useEffect - 当前props数据:', data);
    
    // 如果有保存的数据但当前data为空或部分字段缺失，则从数据库加载
    if (savedData && (!data || Object.keys(data).length === 0)) {
      console.log('Part5Form useEffect - 从数据库加载数据');
      Object.keys(savedData).forEach(key => {
        if (savedData[key] !== null && savedData[key] !== undefined) {
          onChange(key, savedData[key]);
        }
      });
    }
  }, [data, onChange]);
  // 问题列表
  const questions = [
    {
      key: 'child_custody',
      label: '您是否曾经拒绝将一在美国境外的美籍儿童的监护权移交给一被美国法庭批准享有法定监护权的人？',
      icon: Users,
      iconColor: 'text-purple-600'
    },
    {
      key: 'voting_violation',
      label: '您是否违反了法律或规定在美国进行过投票选举？',
      icon: Vote,
      iconColor: 'text-red-600'
    },
    {
      key: 'renounce_exp',
      label: '您是否曾为逃避交税而声明放弃美国公民身份?',
      icon: DollarSign,
      iconColor: 'text-green-600'
    },
    {
      key: 'att_wo_reimb',
      label: '您是否曾经在1996年11月30日之后以学生身份（F类签证持有人）到美国的一公立小学或公立中学就读而没有向学校补交费用？',
      icon: GraduationCap,
      iconColor: 'text-blue-600'
    }
  ];

  // 获取问题的当前值
  const getQuestionValue = (key) => {
    const questionData = data[key];
    if (questionData && typeof questionData === 'object' && 'value' in questionData) {
      return questionData.value;
    }
    // 兼容旧的数据格式
    if (data[key] !== undefined) {
      return data[key];
    }
    // 如果数据未初始化，默认返回 false
    return false;
  };

  // 获取问题的解释文本
  const getQuestionExplanation = (key) => {
    const questionData = data[key];
    if (questionData && typeof questionData === 'object' && 'explanation' in questionData) {
      return questionData.explanation || '';
    }
    return '';
  };

  // 处理是否选择的变化
  const handleYesNoChange = (key, value) => {
    const boolValue = value === 'true';
    const currentData = data[key];
    
    // 如果当前数据是对象格式，更新value字段
    if (currentData && typeof currentData === 'object' && 'value' in currentData) {
      const newData = {
        ...currentData,
        value: boolValue,
        explanation: boolValue ? currentData.explanation : ''
      };
      onChange(key, newData);
    } else {
      // 兼容旧格式，创建新的对象格式
      const newData = {
        value: boolValue,
        explanation: ''
      };
      onChange(key, newData);
    }
  };

  // 处理解释文本的变化
  const handleExplanationChange = (key, explanation) => {
    const currentData = data[key];
    
    // 如果当前数据是对象格式，更新explanation字段
    if (currentData && typeof currentData === 'object' && 'value' in currentData) {
      const newData = {
        ...currentData,
        explanation: explanation
      };
      onChange(key, newData);
    } else {
      // 兼容旧格式，创建新的对象格式
      const newData = {
        value: currentData,
        explanation: explanation
      };
      onChange(key, newData);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-orange-50 to-red-50 p-6 rounded-lg">
        <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <span className="w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center mr-3 text-sm">⚖️</span>
          法律义务和公民身份调查
        </h3>

        {/* 重要提示 */}
        <div className="bg-orange-50 border-l-4 border-orange-400 p-4 mb-6">
          <div className="flex items-start">
            <ShieldAlert className="w-6 h-6 text-orange-600 mt-0.5 mr-3 flex-shrink-0" />
            <div className="text-sm text-orange-800">
              <p className="font-bold mb-2 text-base">重要提示</p>
              <p className="mb-2">以下问题涉及美国法律、公民身份和税务义务。请务必如实回答所有问题。</p>
              <p className="font-semibold">任何虚假陈述都可能导致：</p>
              <ul className="list-disc list-inside mt-1 ml-2">
                <li>签证申请被拒绝</li>
                <li>面临法律起诉</li>
                <li>被禁止入境美国</li>
              </ul>
            </div>
          </div>
        </div>

        {questions.map((question, index) => {
          const questionValue = getQuestionValue(question.key);
          const questionExplanation = getQuestionExplanation(question.key);
          const IconComponent = question.icon;
          
          return (
            <div key={question.key} className="bg-white p-6 rounded-lg shadow-sm mb-6">
              <div className="mb-4">
                <h4 className="text-lg font-semibold text-gray-800 flex items-center mb-4">
                  <IconComponent className={`w-5 h-5 mr-2 ${question.iconColor}`} />
                  {question.label}
                </h4>
                
                <div>
                  
                  <div className="flex gap-6">
                    <label className="flex items-center cursor-pointer p-3 border-2 border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-all duration-200">
                      <input
                        type="radio"
                        name={question.key}
                        value="false"
                        checked={questionValue === false}
                        onChange={(e) => {
                          handleYesNoChange(question.key, 'false');
                        }}
                        className="mr-3 w-5 h-5 text-blue-600 border-gray-300 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                      />
                      <span className="text-base font-medium text-gray-700">❌ 否 - 我没有此类情况</span>
                    </label>
                    
                    <label className="flex items-center cursor-pointer p-3 border-2 border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-all duration-200">
                      <input
                        type="radio"
                        name={question.key}
                        value="true"
                        checked={questionValue === true}
                        onChange={(e) => {
                          handleYesNoChange(question.key, 'true');
                        }}
                        className="mr-3 w-5 h-5 text-blue-600 border-gray-300 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                      />
                      <span className="text-base font-medium text-gray-700">✅ 是 - 我有此类情况</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* 如果选择"是"，显示解释文本框和警告信息 */}
              {questionValue === true && (
                <div className="mt-4 space-y-3">
                  <div className="bg-red-50 border-2 border-red-400 rounded-lg p-4 animate-pulse">
                    <div className="flex items-start">
                      <AlertTriangle className="w-6 h-6 text-red-600 mt-0.5 mr-3 flex-shrink-0" />
                      <div className="text-sm text-red-800">
                        <p className="font-bold text-base mb-2">⚠️ 重要风险警告</p>
                        <p className="mb-2">
                          <span className="font-bold">选择"是"将大幅增加拒签风险！</span>
                          此选项可能导致：
                        </p>
                        <ul className="list-disc list-inside ml-2 space-y-1">
                          <li className="font-semibold">面签时遭到严格审查</li>
                          <li className="font-semibold">签证申请被拒绝</li>
                          <li className="font-semibold">可能面临永久拒签</li>
                        </ul>
                        <p className="mt-3 font-bold text-red-900 bg-red-100 p-2 rounded">
                          💡 强烈建议：如无必要，请仔细核实后选择"否"。如确实存在相关情况，请立即咨询专业移民律师！
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      请详细说明：
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <textarea
                      value={questionExplanation}
                      onChange={(e) => handleExplanationChange(question.key, e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                      rows={4}
                      placeholder="请详细说明相关情况，包括时间、地点、原因等..."
                      required
                    />
                    {!questionExplanation && (
                      <p className="text-sm text-red-600">请提供详细说明</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}

        {/* 法律提醒 */}
        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
          <div className="flex items-start">
            <AlertTriangle className="w-5 h-5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" />
            <div className="text-sm text-blue-800">
              <p className="font-semibold mb-1">法律提醒</p>
              <p>根据美国法律，某些行为可能导致您不符合签证资格。然而，在某些情况下，可能存在豁免或例外。</p>
              <p className="mt-2">如果您对任何问题的回答是"是"，强烈建议您：</p>
              <ul className="list-disc list-inside mt-1 ml-2">
                <li>在提交申请前咨询有经验的移民律师</li>
                <li>准备相关的解释文件和证明材料</li>
                <li>了解可能适用的豁免条款</li>
                <li>确保所有税务义务已妥善处理</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Part5Form; 
